let views_filters = document.querySelectorAll('.n-views-filters');
if(views_filters.length > 0){
  for(var i = 0 ; i < views_filters.length ; i++){
    
    let form = views_filters[i].querySelector('form');

    // Auto-submit on select change
    let selects = form.querySelectorAll('select');
    
    if(selects.length == 0) continue;
    
    selects.forEach( s => {
      jQuery(s).on('change', function(e,p){
        form.submit();
        s.disabled = true;
      });
    });

    // Hide submit button
    form.querySelector('.form-actions').style.display = 'none';

    // Filters toggler
    let toggler = views_filters[i].querySelector('.views-filters--toggler');
    let toggled = views_filters[i].querySelector('.views-filters--form');
    toggled.classList.add('--hidden');
    toggler.addEventListener('click', function(){
      toggled.classList.toggle('--hidden');
    });

  }
}
